import React from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

const Payment = ({ packageDetails, formData, navigate }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handlePayment = async (event) => {
    event.preventDefault();
    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.error('Error creating payment method:', error);
      return;
    }

    // Send paymentMethod.id and other details to your server
    try {
      const response = await fetch("https://portal.virtualtriage.ca/api/v1/doctor/signup/packages/", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email, // Use formData passed from DoctorSignup
          charge_token: paymentMethod.id,
          package_id: packageDetails.id,
          card_details_status: "registration",
        }),
      });

      if (!response.ok) {
        throw new Error('Payment failed');
      }

      const data = await response.json();
      console.log('Payment successful:', data);
      // Redirect or show success message
      navigate('/homepage'); // Redirect to a success page or show a success message
    } catch (error) {
      console.error('Error during payment:', error);
    }
  };

  return (
    <form onSubmit={handlePayment}>
      <h3>Proceed with payment for {packageDetails.name} - ${packageDetails.price}</h3>
      <CardElement />
      <button type="submit" disabled={!stripe}>Pay Now</button>
    </form>
  );
};

export default Payment;